import { useState } from "react";
import useSWR from "swr";
import {
  ActionIcon,
  Badge,
  Group,
  Loader,
  Menu,
  Paper,
  ScrollArea,
  Stack,
  Text,
} from "@mantine/core";
import { fetcher } from "../../../services/fetcher";
import { SalesFollowups_Api } from "../../../api/endpoints";
import { FormatDate } from "../../../helper/DateFormatting";

const DUE_TODAY_URL = `${SalesFollowups_Api}?ordering=-due_date&page=1&page_size=25&status=DUE_TODAY`;

const PRIORITY_COLOR = {
  CRITICAL: "red",
  HIGH: "orange",
  MEDIUM: "blue",
  LOW: "gray",
};

const NotificationComponent = () => {
  const [opened, setOpened] = useState(false);
  const { data, error, isLoading } = useSWR(opened ? DUE_TODAY_URL : null, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });
  const items = data?.results || data?.data || (Array.isArray(data) ? data : []);

  return (
    <Menu
      width={340}
      position="bottom-end"
      withArrow
      shadow="md"
      withinPortal
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <ActionIcon variant="transparent" size={28} aria-label="Follow-ups due today">
          <img src="/images/svg/notification-icon.svg" width={24} height={24} alt="" />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown p="sm">
        <Text fw={600} size="sm" mb="xs">
          Due Today{data?.count != null ? ` (${data.count})` : ""}
        </Text>
        {isLoading ? (
          <Group justify="center" py="md">
            <Loader size="sm" color="orange" />
          </Group>
        ) : error ? (
          <Text c="red" size="sm">
            Failed to load follow-ups
          </Text>
        ) : items.length === 0 ? (
          <Text size="sm" c="dimmed">
            No follow-ups due today
          </Text>
        ) : (
          <ScrollArea.Autosize mah={320} offsetScrollbars>
            <Stack gap="xs">
              {items.map((item, index) => (
                <Paper key={item.id ?? index} withBorder p="xs" radius="md">
                  <Group justify="space-between" wrap="nowrap" gap="xs" mb={4}>
                    <Text size="sm" fw={600} truncate>
                      {item.person_name || item.lead_name || "-"}
                    </Text>
                    <Badge
                      size="xs"
                      variant="light"
                      color={PRIORITY_COLOR[item.priority] || "gray"}
                    >
                      {item.priority || "-"}
                    </Badge>
                  </Group>
                  <Text size="xs" c="dimmed">
                    {[
                      item.followup_type?.replaceAll("_", " "),
                      item.due_date ? FormatDate(item.due_date, "date") : null,
                      item.phone,
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </Text>
                  {item.notes ? (
                    <Text size="xs" c="dimmed" lineClamp={2} mt={4}>
                      {item.notes}
                    </Text>
                  ) : null}
                </Paper>
              ))}
            </Stack>
          </ScrollArea.Autosize>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};

export default NotificationComponent;
